import api from '@/api/follows'
import apiReviews from '@/api/reviews'
import errors from '@/api/errors'

const state = {
  // internal
  internal: {},
  query: {},
  // view
  count: 0,
  follows: []
}

const getters = {
  count: state => state.count,
  follows: state => state.follows
}

const mutations = {
  initialize: (state, args) => {
    state.internal = args
  },
  updateQuery: (state, newQuery) => {
    Object.assign(state.query, newQuery)
  },
  setFollows: (state, data) => {
    state.count = data.count_follow
    state.follows = data.lists
  },
  addFollows: (state, data) => {
    state.follows.push(...data.lists)
  }
}

const actions = {
  /**
   * 初期化
   */
  initialize: ({ commit }, args) => {
    commit('initialize', args)
  },
  /**
   * フォロー登録
   */
  registerFollow: ({ dispatch }, args) => {
    dispatch('commons/setLoadingPost', { isLoading: true }, { root: true })
    dispatch('commons/clearGlobalError', {}, { root: true })
    const params = {
      targetUser: args.targetUser
    }
    return api.registerFollow(params).then(data => {
      dispatch('storeUsers/setEntryFollow', {
        isEntryFollow: 1, // 1:フォロー登録済み
        followId: data.follow_id
      }, { root: true })
      .then(() => {
        dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      })
    }).catch(error => {
      dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      if (error instanceof errors.AuthenticationError) {
        dispatch('commons/setGlobalError', error, { root: true })
      } else {
        return Promise.reject(Error('問題が発生したため処理を継続することができませんでした。'))
      }
    })
  },
  /**
   * フォロー解除
   */
  deleteFollow: ({ dispatch }, args) => {
    dispatch('commons/setLoadingPost', { isLoading: true }, { root: true })
    dispatch('commons/clearGlobalError', {}, { root: true })
    const params = {
      followId: args.followId
    }
    return api.deleteFollow(params).then(data => {
      dispatch('storeUsers/setEntryFollow', {
        isEntryFollow: 0, // 0:フォロー未登録
        followId: 0
      }, { root: true })
      .then(() => {
        dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      })
    }).catch(error => {
      if (error instanceof errors.AuthenticationError) {
        dispatch('commons/setGlobalError', error, { root: true })
      } else {
        return Promise.reject(Error('問題が発生したため処理を継続することができませんでした。'))
      }
    })
  },
  /**
   * フォロー一覧取得
   */
  getFollows: ({ dispatch, commit }) => {
    dispatch('commons/setLoadingAll', { isLoading: true }, { root: true })
    dispatch('commons/clearGlobalError', {}, { root: true })
    const params = Object.assign({}, state.query, {
      start: 0,
      count: state.internal.pageSize,
      sort: state.internal.sortOrder
    })
    return api.getFollow(params).then(data => {
      return data.lists.reduce((data, follow) => {
        if (follow.nickname) {
          return apiReviews.getReviews({
            nicknames: [ follow.nickname ],
            sort: '1',
            sort_item: 0,
            start: 0,
            count: 1,
            status: ['2'],
            is_image: '0',
            is_helpful: '0',
            is_follow: '0',
            is_clip: '0',
            is_comment: '0'
          })
          .then(reviewData => {
            follow.recent_review = reviewData.lists.length ? reviewData.lists[0] : {}
            return data
          })
        } else {
          follow.nickname = ''
          follow.recent_review = {}
          return data
        }
      }, data)
    })
    .then(data => {
      commit('setFollows', data)
      commit('updateQuery', params)
    })
    .catch(error => {
      dispatch('commons/setGlobalError', error, { root: true })
    })
    .then(() => {
      dispatch('commons/setLoadingAll', { isLoading: false }, { root: true })
    })
  },
  /**
   * もっと見る
   */
  getMoreFollows: ({ dispatch, commit }) => {
    dispatch('commons/setLoadingMore', { isLoading: true }, { root: true })
    dispatch('commons/clearGlobalError', {}, { root: true })
    const params = Object.assign({}, state.query, {
      start: state.follows.length,
      count: state.internal.pageSizeMore
    })
    return api.getFollow(params).then(data => {
      return data.lists.reduce((data, follow) => {
        if (follow.nickname) {
          return apiReviews.getReviews({
            nicknames: [ follow.nickname ],
            sort: '1',
            sort_item: 0,
            start: 0,
            count: 1,
            status: ['2'],
            is_image: '0',
            is_helpful: '0',
            is_follow: '0',
            is_clip: '0',
            is_comment: '0'
          })
          .then(reviewData => {
            follow.recent_review = reviewData.lists.length ? reviewData.lists[0] : {}
            return data
          })
        } else {
          follow.nickname = ''
          follow.recent_review = {}
          return data
        }
      }, data)
    })
    .then(data => {
      commit('addFollows', data)
      commit('updateQuery', params)
      dispatch('commons/setLoadingMore', { isLoading: false }, { root: true })
    }).catch(error => {
      dispatch('commons/setLoadingMore', { isLoading: false }, { root: true })
      if (error instanceof errors.AuthenticationError) {
        dispatch('commons/setGlobalError', error, { root: true })
      } else {
        return Promise.reject(Error('問題が発生したため処理を継続することができませんでした。'))
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/follows.js